import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import { ContactUs } from "./scripts/contact-us";



let domContainer = document.querySelector('#root');
const root = createRoot(domContainer);
root.render(
  <React.StrictMode>
    <Router basename={domContainer.getAttribute('data-basename')}>
      <ContactUs />
    </Router>
  </React.StrictMode>
);